module.exports = kolibriGlobal.coreVue.components.PrivacyInfoModal;